<template>
  <div class="small_genre_article_list">
      <div v-for="(articleHtml, index) in articleHtmlList" :key="index" v-html="articleHtml"></div>
      <div class="show_more_btn" v-show="hasMorePage" v-on:click="fetchArticleList">もっと見る</div>
    <div id="app" class="loaded-wall" v-show="loading">
      <div v-show="loading" class="loader-container">
        <div class="loader-wall"></div>
      </div>
    </div>
  </div>
 </template>

<script>
import Mixin from '../../mixin/Mixin'
import SmallGenreApiClass from '../../../mixin/js/internal-api/small-genre-api'
let SmallGenreApi = new SmallGenreApiClass;

export default {
  components: {
  },
  mixins: [Mixin],
  props: {
    genre : {
      type: String
    },
  },
  data () {
    return {
      page: 1,
      loading: false,
      hasMorePage: false,
      articleHtmlList: [],
      theaterProductObj: {},
      product: {},
      showtimes: {},
    }
  },
  mounted () {
    Promise.all([
        this.fetchArticleList(),
      ]).then(results => {
        this.loading = false;
      });
  },
  methods: {
    async fetchArticleList() {      
      if(this.loading) {
        return;
      }
      this.loading = true;
      const articleData = await SmallGenreApi.getArticles(this.genre, this.smallGenre, this.page);
      this.loading = false;
      if(!Object.keys(articleData).length) {
        return;
      }
      this.articleHtmlList.push(articleData['data']);
      this.hasMorePage = articleData['hasMorePage'];
      this.page++;
    },
  }
}
</script>
<style lang='scss'>
  .loader-container {
    height: inherit;
    margin-bottom: 40px;
  }
</style>